<template>
  <div>
    <v-card>
      <v-card-title>
        <span>{{ title }}</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="close()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row v-if="!realTime">
          <v-col>
            <v-card>
              <v-card-text class="mb-2">
                <v-row>
                  <v-col
                    cols="12"
                    md="5"
                  >
                    <koiote-date-picker
                      dateLabel="Fecha Inicio"
                      hourLabel="Hora Inicio"
                      :type="1"
                    ></koiote-date-picker>
                  </v-col>
                  <v-col
                    cols="12"
                    md="5"
                  >
                    <koiote-date-picker
                      dateLabel="Fecha Fin"
                      hourLabel="Hora Fin"
                      :type="2"
                    ></koiote-date-picker>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    class="d-flex align-self-center"
                  >
                    <!-- <v-btn
                      block
                      @click="addDataToVariable()"
                    >
                      Buscar
                    </v-btn> -->
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-select
            v-model="selected_variator"
            :items="variators"
            item-text="name"
            label="Seleccione un Variador"
            return-object
            @change="getVariatorsVariables()"
          >
          </v-select>
        </v-row>
        <v-row>
          <!-- Sidebar (10%) -->
          <!-- Contenido de la barra lateral -->
          <v-col
            v-if="!realTime && selected_variator"
            cols="3"
            class="sidebar"
          >
            <v-card class="scrollable-card">
              <v-card-title>Seleccionar variables</v-card-title>
              <v-card-text>
                <v-list>
                  <v-list-item-group
                    v-model="selected_variables"
                    multiple
                    color="blue"
                    @change="addDataToVariable()"
                  >
                    <v-list-item
                      v-for="(item, index) in available_variables"
                      :key="index"
                      :value="item"
                    >
                      <v-list-item-title class="body-2">{{ item.id }} - {{ item.name }}</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
  
          <!-- Main Content (90%) -->
          <v-col :cols="realTime ? 12 : 9">
            <!-- Contenido principal -->
            <v-card class="scrollable-card">
              <v-card-text>
                <template v-if="!selected_variables.length">
                  <div>Seleccione al menos una variable para visualizar la gráfica.</div>
                </template>
                <template v-else-if="!loading && !computed_chart_data?.datasets?.length">
                  <div>No se han encontrado datos para las fechas seleccionadas.</div>
                </template>
                <template v-else>
                  <!-- Gráfica-->
                  <v-row v-if="loading">
                    <v-col>
                      <v-progress-linear
                        indeterminate
                        color="primary"
                      ></v-progress-linear>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <line-chart
                        :chart-data="computed_chart_data"
                        @render-complete="onRenderComplete"
                      ></line-chart>
                    </v-col>
                  </v-row>
                  <!-- Tabla  con los datos -->
                  <template v-if="!realTime">
                    <v-row>
                      <v-col cols="9">
                        <h2>Detalles</h2>
                      </v-col>
                      <v-col cols="3">
                        <v-btn
                          dark
                          color="#da4726"
                          @click="downloadData()"
                        >
                          <v-icon class="mr-1">mdi-file-download</v-icon>
                          DESCARGAR
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-data-table
                          :headers="table_header"
                          :items="table_data"
                        >
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </template>
                </template>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from "moment-timezone";
import * as XLSX from "xlsx";

import { mapGetters, mapActions } from "vuex";

import LineChart from "@/components/utils/LineChart.vue";
import KoioteDatePicker from "@/components/utils/KoioteDatePicker.vue";

export default {
  components: {
    LineChart,
    KoioteDatePicker,
  },

  props: {
    title: String,
    realTime: Boolean,
    address: String,
  },

  data() {
    return {
      available_variables: [],
      selected_variables: [],

      chart_data: {},
      table_data: [],

      loading: true,

      variators: [],
      selected_variator: null,

      variables_dialog: false,
      variables: [],
    };
  },

  computed: {
    connection() {
      return this.actualPage()?.global_item_list?.find((gi) => gi.settings.component_type.includes("connection"))
        ?.customized;
    },

    computed_chart_data() {
      return this.realTime
        ? {
            datasets: [
              {
                data: this.getHistoryValues().map((d) => d.formatted_value),
                label: this.selected_variables[0].description,
                backgroundColor: "#2b90c2",
                segment: { borderColor: "#2b90c2" },
                pointRadius: 0,
              },
            ],
            labels: this.getHistoryValues().reduce(function (timestamps, chartData) {
              if (!timestamps.includes(chartData.formatted_timestamp)) timestamps.push(chartData.formatted_timestamp);
              return timestamps;
            }, []),
          }
        : this.chart_data;
    },

    table_header() {
      const headers = this.selected_variables?.map((v) => ({ text: `${v?.name} Variador ${v?.variator_id}`, value: `${v?.id}` }));
      headers.unshift({ text: "Fecha", value: "read_at" });
      return headers;
    },
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapGetters("utils", ["getInitDateFilter", "getEndDateFilter"]),
    ...mapGetters("nodered", ["getHistoryValues"]),
    ...mapActions(["getData", "setSelectedPage", "loadPages"]),

    async addDataToVariable() {
      this.loading = true;
      // console.log("selected variabkels", this.selected_variables);
      const params = {
        id: JSON.stringify(this.selected_variables?.map((v) => v.id)),
        initDate: this.getInitDateFilter(),
        endDate: this.getEndDateFilter(),
      };

      const { data, history_data } = await this.getData({
        path: `variadores/variables/history/chart`,
        params: params,
      });

      // preprocesamiento para unir en el mismo read_at
      const mergedData = history_data.reduce((acc, item) => {
        const existe = acc.find(obj => obj.read_at == item.read_at);

        if(existe) Object.assign(existe, item);
        else acc.push(item);
        
        return acc;
      }, []);

      this.table_data = mergedData;
      this.chart_data = data;

      // console.log("computed", this.computed_chart_data);
      

      // chartData.labels = chartData?.labels?.map((date) =>
      //   moment.tz(date, moment.tz.guess()).format("DD/MM/YYYY HH:mm:ss")
      // );

      // this.chart_data = chartData;

      // this.table_data = table_data?.map((td) => ({
      //   ...td,
      //   read_at: moment.tz(td?.read_at, moment.tz.guess()).format("DD/MM/YYYY HH:mm:ss"),
      // }));
    },

    //recoger variables de variador seleccionado
    async getVariatorsVariables() {
      const { variables } = await this.getData({
        path: `variadores/variables/${this.selected_variator.id}`
      });
      this.available_variables = variables;
    },

    downloadData() {
      if (this.table_header.length > 1) {
        const ws = XLSX.utils.aoa_to_sheet([this.table_header?.map((header) => header.text)]);
        this.table_data.forEach((item) => {
          const row = this.table_header?.map((header) => (item[header.value] !== null ? item[header.value] : ""));
          XLSX.utils.sheet_add_aoa(ws, [row], { origin: -1 });
        });
        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, ws, "Data");
        const file_name = "datos_variables_seleccionadas";
        XLSX.writeFile(wb, file_name + ".xlsx");
      }
    },

    close() {
      this.$emit("close");
    },

    onRenderComplete() {
      this.loading = false;
    },
  },

  async created() {
    await this.loadPages();
    this.setSelectedPage(this.$route.params.page_index);

    //recoger variadores de bbdd
    const { variadores } = await this.getData({
      path: "variadores/",
    });
    // console.log(variadores);
    this.variators = variadores;

    // if (this.address) {
    //   this.selected_variables = [this.available_variables.find((v) => v.formatted_address == this.address)];
    // }
  },
};
</script>

<style>
.scrollable-card {
  max-height: 600px;
  overflow-y: auto;
}
</style>
